import React, { createContext, useContext, useState } from 'react'

const PatternContext = createContext()

export function PatternProvider({ children }) {
  const [formData, setFormData] = useState({
    produto: '',
    prompt: '',
    categoria: '',
    tema: '',
    estiloArtistico: 0,
    variedadeVisual: 75,
    criatividade: 80,
    semEmendas: true,
    files: [],
  })

  const updateFormData = (newData) => {
    setFormData((prev) => ({
      ...prev,
      ...newData,
    }))
  }

  return (
    <PatternContext.Provider
      value={{
        formData,
        updateFormData,
      }}
    >
      {children}
    </PatternContext.Provider>
  )
}

export function usePatternContext() {
  const context = useContext(PatternContext)
  if (!context) {
    throw new Error('usePatternContext must be used within a PatternProvider')
  }
  return context
}
